function initFilterDrawer() {
  const filterDrawer = document.getElementById('filter-drawer');
  const filterPanel = document.getElementById('filter-panel');
  const filterOverlay = document.getElementById('filter-overlay');
  const filterTrigger = document.querySelector('[data-filter-trigger]');
  const closeFilterBtn = document.getElementById('close-filter');
  const filterSections = document.querySelectorAll('[data-filter-section]');
  const clearFiltersBtn = document.querySelector('[data-clear-filters]');
  const applyFiltersBtn = document.querySelector('[data-apply-filters]');

  // Only initialize if we're on a page with the filter drawer
  if (!filterDrawer) return;

  // Remove any checkboxes that don't have a proper label or have empty values
  function cleanupEmptyCheckboxes() {
    const allInputs = filterDrawer.querySelectorAll('input[type="checkbox"]');
    allInputs.forEach(input => {
      // Check if input has a proper parent label with text content
      const parentLabel = input.closest('label');
      if (!parentLabel || !parentLabel.textContent.trim()) {
        if (parentLabel) {
          parentLabel.remove(); // Remove the entire label if it exists but is empty
        } else {
          input.remove(); // Remove just the input if there's no label
        }
      }
      
      // Also check if the value is empty or blank
      if (!input.value || input.value.trim() === '') {
        const parent = input.parentNode;
        if (parent && parent.tagName === 'LABEL') {
          parent.remove(); // Remove the entire label if parent is a label
        } else {
          input.remove(); // Otherwise just remove the input
        }
      }
      
      // For length filter, make sure only numeric values are displayed
      if (input.name === 'filter.v.option.length') {
        const value = input.value.trim();
        const firstChar = value.charAt(0);
        const isNumeric = /[0-9]/.test(firstChar);
        
        if (!isNumeric) {
          const parent = input.closest('label');
          if (parent) {
            parent.remove();
          } else {
            input.remove();
          }
        }
      }
    });
  }

  // Run cleanup after initialization
  setTimeout(cleanupEmptyCheckboxes, 100);
  
  // Also run cleanup after any DOM changes that might introduce new checkboxes
  const observer = new MutationObserver(mutations => {
    cleanupEmptyCheckboxes();
  });
  
  observer.observe(filterDrawer, {
    childList: true,
    subtree: true
  });

  function openFilterDrawer() {
    filterDrawer.classList.remove('invisible', 'opacity-0');
    filterPanel.classList.remove('-translate-x-full');
    document.body.style.overflow = 'hidden';
    // Clean up empty checkboxes when opening drawer
    cleanupEmptyCheckboxes();
  }

  function closeFilterDrawer() {
    filterDrawer.classList.add('opacity-0');
    filterPanel.classList.add('-translate-x-full');
    document.body.style.overflow = '';
    setTimeout(() => {
      filterDrawer.classList.add('invisible');
    }, 500);
  }

  // Toggle filter sections
  filterSections.forEach(section => {
    const sectionId = section.getAttribute('data-filter-section');
    const button = section.querySelector('button');
    const content = document.querySelector(`[data-filter-content="${sectionId}"]`);
    const icon = button?.querySelector('[data-filter-icon]');
    
    if (button && content && icon) {
      button.addEventListener('click', () => {
        // Close other sections
        filterSections.forEach(otherSection => {
          if (otherSection !== section) {
            const otherSectionId = otherSection.getAttribute('data-filter-section');
            const otherContent = document.querySelector(`[data-filter-content="${otherSectionId}"]`);
            const otherIcon = otherSection.querySelector('[data-filter-icon]');
            if (otherContent) otherContent.classList.add('hidden');
            if (otherIcon) otherIcon.classList.remove('rotate-45');
          }
        });
        
        content.classList.toggle('hidden');
        icon.classList.toggle('rotate-45');
      });
    }
  });

  // Event listeners
  if (filterTrigger) {
    filterTrigger.addEventListener('click', (e) => {
      e.preventDefault();
      openFilterDrawer();
    });
  }
  
  if (closeFilterBtn) {
    closeFilterBtn.addEventListener('click', closeFilterDrawer);
  }
  
  if (filterOverlay) {
    filterOverlay.addEventListener('click', closeFilterDrawer);
  }

  // Clear filters
  if (clearFiltersBtn) {
    clearFiltersBtn.addEventListener('click', () => {
      const checkboxes = filterDrawer.querySelectorAll('input[type="checkbox"]');
      checkboxes.forEach(checkbox => checkbox.checked = false);
    });
  }

  // Apply filters
  if (applyFiltersBtn) {
    applyFiltersBtn.addEventListener('click', () => {
      // Create a form to submit
      const form = document.createElement('form');
      form.method = 'get';
      form.action = window.location.pathname;
      
      // Add filter parameters from checked checkboxes
      const checkboxes = filterDrawer.querySelectorAll('input[type="checkbox"]:checked');
      
      // Group checkboxes by their name
      const filterGroups = {};
      
      checkboxes.forEach(checkbox => {
        const name = checkbox.name;
        const value = checkbox.value;
        
        if (!filterGroups[name]) {
          filterGroups[name] = [];
        }
        
        filterGroups[name].push(value);
      });
      
      // Add each filter group to the form
      for (const [name, values] of Object.entries(filterGroups)) {
        values.forEach(value => {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          input.value = value;
          form.appendChild(input);
        });
      }
      
      // Keep existing sort parameter if present
      const sortBy = new URLSearchParams(window.location.search).get('sort_by');
      if (sortBy) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'sort_by';
        input.value = sortBy;
        form.appendChild(input);
      }
      
      // Keep existing search query if present
      const searchQuery = new URLSearchParams(window.location.search).get('q');
      if (searchQuery) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'q';
        input.value = searchQuery;
        form.appendChild(input);
      }
      
      // Submit the form
      document.body.appendChild(form);
      form.submit();
    });
  }

  // Activate filters based on URL parameters
  function activateFiltersFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    const checkboxes = filterDrawer.querySelectorAll('input[type="checkbox"]');
    
    checkboxes.forEach(checkbox => {
      const name = checkbox.name;
      const value = checkbox.value;
      const paramValues = urlParams.getAll(name);
      
      if (paramValues.includes(value)) {
        checkbox.checked = true;
      }
    });
  }

  // Run activation after initialization
  activateFiltersFromURL();
}

// Initialize the filter drawer when the DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
  initFilterDrawer();
}); 